import { WithSitecoreContextProps } from "@sitecore-jss/sitecore-jss-react/types/enhancers/withSitecoreContext";

export type TContentHubSeriesDetailsProps = WithSitecoreContextProps & {
  fields: TContentHubSeriesDetailsFields;
};

export enum InnerComponentTypes {
  Split = "split",
  Card = "card",
}

export type TContentHubSeriesDetailsFields = {
  apiData: TSeriesDetailsData;
};

export type TBreadcrumb = {
  titleUrl: string;
  title: string;
};
export type TButton = {
  label: string;
  url: string;
};

export type TSummarySpec = {
  key: string;
  value: string;
  active?: string;
  position?: string;
  status?: string;
};

export type TComponentTab = {
  key: string;
  value: string;
};

export type TAsset = {
  role: string;
  position: number;
  alt: string;
  bigthumbnail: string;
  thumbnail: string;
  full: string;
};

export type TSeo = {
  title: string;
  description: string;
  keywords: string;
  ogTitle: string;
  ogType: string;
  ogImage: string;
  ogUrl: string;
  ogDescription: string;
  ogSiteName: string;
  jsonLdSchema: string;
  canonicalUrl: string;
};

export type TImage = {
  image?: string;
  imageAlt?: string;
  imageMobile?: string;
  imageAltMobile?: string;
};

export type TSeriesDetailsData = {
  id: number;
  titleUrl?: string;
  title?: string;
  formattedTitle?: string;
  eyebrow?: string;
  innerComponents?: TComponentDetails[];
  description?: string;
  msrp?: string;
  optionalLabel1?: string;
  optionalLabel2?: string;
  breadcrumb?: TBreadcrumb[];
  button1?: TButton;
  button2?: TButton;
  button3?: TButton;
  summarySpecs?: TSummarySpec[];
  components?: TComponentTab[];
  active?: boolean;
  showInNavigation?: boolean;
  assets?: TAsset[];
  videoUrl?: string;
  seo?: TSeo;
};

export type TComponentDetails = {
  id: number;
  componentType?: InnerComponentTypes;
  title?: string;
  layoutType?: string;
  eyebrow?: string;
  description?: string;
  button1?: TButton;
  button2?: TButton;
  image?: string;
  imageAlt?: string;
  assets?: TAsset[];
  videoUrl?: string;
  videoDescription?: string;
  innerComponents?: TComponentDetails[];
};

export type TComponentDetailsProps = {
  className?: string;
  component: TComponentDetails;
};

export type TBannerProps = {
  className?: string;
  component: TComponentDetails;
  hasFixedAspectRatio?: boolean;
};

export type TGalleryProps = {
  assets?: TAsset[];
  hasFixedAspectRatio?: boolean;
};

export type TModalComponentsListProps = {
  components: Array<TComponentDetails>;
};

export type TModalComponentsItemProps = {
  component: TComponentDetails;
};
